import './ActiveMessages.scss';
import { debounce } from 'data/function';
import { ChannelsNames } from 'modules/application/detail/channels/Channels';
import LiteApiModalView from '../activeMessages/modals/LiteApiModalView.html';
import { LiteApiModalController } from '../activeMessages/modals/LiteApiModalController';
import { ActiveMessagesConstants } from './ActiveMessagesConstants';
import { BlipToastDuration } from 'modules/shared/BlipToastService';
import { GROWTH_ACTIVE_MESSAGE_WA_REPORT_BUTTON_CLICKED, GROWTH_ACTIVE_MESSAGE_WA_SENT_ACTIVE_MESSAGE_BUTTON_CLICKED, GROWTH_ACTIVE_MESSAGE_WA_STARTED, GROWTH_ACTIVE_MESSAGE_WA_CAMPAIGN_SCHEDULED_EDITED_BUTTON_CLICKED, GROWTH_ACTIVE_MESSAGE_WA_CAMPAIGN_DELETED, GROWTH_ACTIVE_MESSAGE_WA_SHOW_SCHEDULED_CAMPAIGN, GROWTH_ACTIVE_MESSAGE_VIEW_DATA_LITE_API, GROWTH_ACTIVE_MESSAGE_ERROR_LITE_API, } from '../GrowthSegmentEvents';
import { PhoneNumberScore, PhoneNumberStatus } from '../../channels/whatsapp/WhatsAppResources';
import { ActiveMessagesFeatures } from './ActiveMessagesFeatures';
import { blipDomainUrl, blipWebsocketHostName, blipWebsocketHostNameTenant, messaginghubWebsocketHostName, messaginghubWebsocketHostNameTenant, activeCampaignMfeSettingsSource, } from 'app.constants';
import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
import { FeatureToggleClientService } from 'feature-toggle-client';
import moment from 'moment';
export class ActiveMessagesController {
    static $inject = ['ChannelsService', 'LoadingService', 'ActiveMessageService', 'ModalService', 'application', '$translate', 'GrowthSegmentService', 'WhatsAppService', 'AlertService', '$state', 'BlipToastService', 'AccountService2', 'TranslateService', 'ApplicationService2', 'AuthenticationService', '$cookies', 'FacebookLoginPopupService', 'MARKETING_MESSAGES_LITE_API_CONFIGID', 'FACEBOOK_POPUP_CONNECTION_TIME'];
    constructor(ChannelsService, LoadingService, ActiveMessageService, ModalService, application, $translate, GrowthSegmentService, WhatsAppService, AlertService, $state, BlipToastService, AccountService2, TranslateService, ApplicationService2, AuthenticationService, $cookies, FacebookLoginPopupService, MARKETING_MESSAGES_LITE_API_CONFIGID, FACEBOOK_POPUP_CONNECTION_TIME) {
        'ngInject';
        this.ChannelsService = ChannelsService;
        this.LoadingService = LoadingService;
        this.ActiveMessageService = ActiveMessageService;
        this.ModalService = ModalService;
        this.application = application;
        this.$translate = $translate;
        this.GrowthSegmentService = GrowthSegmentService;
        this.WhatsAppService = WhatsAppService;
        this.AlertService = AlertService;
        this.$state = $state;
        this.BlipToastService = BlipToastService;
        this.AccountService2 = AccountService2;
        this.TranslateService = TranslateService;
        this.ApplicationService2 = ApplicationService2;
        this.AuthenticationService = AuthenticationService;
        this.$cookies = $cookies;
        this.FacebookLoginPopupService = FacebookLoginPopupService;
        this.MARKETING_MESSAGES_LITE_API_CONFIGID = MARKETING_MESSAGES_LITE_API_CONFIGID;
        this.FACEBOOK_POPUP_CONNECTION_TIME = FACEBOOK_POPUP_CONNECTION_TIME;
        this.activeCampaigns = [];
        this.skip = ActiveMessagesConstants.PAGINATION_DEFAULT_SKIP;
        this.take = ActiveMessagesConstants.PAGINATION_DEFAULT_TAKE;
        this.search = '';
        this.isNewCampaignListingActive = ActiveMessagesFeatures.newCampaignListingActiveDefaultValue;
        this.showInProcessingActiveCampaignListing = ActiveMessagesFeatures.showInProcessingActiveCampaignListingDefaultValue;
        this.changesDisplayActiveCampaignData = ActiveMessagesFeatures.changesDisplayActiveCampaignDataDefaultValue;
        this.showScheduledOnly = false;
        this.isDownloadingReport = new Map();
        this.readyToRender = false;
        this.blipDomainUrl = blipDomainUrl;
        this.blipWebsocketHostName = messaginghubWebsocketHostNameTenant;
        this.blipWebsocketHostNameTenant = messaginghubWebsocketHostNameTenant;
        this.settingsSource = activeCampaignMfeSettingsSource;
        this.isEnabledActiveCampaignMFE = ActiveMessagesFeatures.activeCampaignMfeDefaultValue;
        this.isLoadingLiteApiData = new Map();
        this.toggleScheduledOnly = async () => {
            this.showScheduledOnly = !this.showScheduledOnly;
            this.reset();
            await this.GetAudiencesSummary(true);
            this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_SHOW_SCHEDULED_CAMPAIGN, { showScheduledOnly: this.showScheduledOnly });
        };
    }
    async $onInit() {
        try {
            this.LoadingService.startLoading();
            this.isEnabledActiveCampaignMFE = await ActiveMessagesFeatures.isEnabledActiveCampaignMFE();
            if (this.isEnabledActiveCampaignMFE) {
                await this.LoadActiveCampaignMfe();
            }
            else {
                await this.LoadActiveCampaign();
            }
            await this.startForLiteApi();
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async startForLiteApi() {
        this.subsidiary = await this.ChannelsService.getSubsidiary(ChannelsNames.WhatsApp);
        const { AppId, GraphApiVersion } = await this.loadApplicationInformation();
        this.graphApiVersion = GraphApiVersion;
        this.nativeAppId = AppId;
        this.marketingMessagesLiteApiFeature = await ActiveMessagesFeatures.isMarketingMessagesLiteApiEnabled();
    }
    async LoadActiveCampaign() {
        this.isNewCampaignListingActive = await ActiveMessagesFeatures.isNewCampaignListingActive();
        this.showInProcessingActiveCampaignListing = await ActiveMessagesFeatures.isToShowInProcessingActiveCampaignListing();
        this.changesDisplayActiveCampaignData = await ActiveMessagesFeatures.isChangesDisplayActiveCampaignData();
        await this.ChannelsService.init(this.application);
        await this.GetAudiencesSummary(false);
        await this.getOrderByOptionsTranslations();
        await this.GetPhoneNumberQuality();
        this.orderBy = 'lastUpdate';
        this.debouncedSearch = debounce(this.searchDebounce, 500);
        this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_STARTED);
    }
    async LoadActiveCampaignMfe() {
        try {
            const me = await this.AccountService2.me();
            const userToken = this.AuthenticationService.token;
            const userEmail = encodeURIComponent(me.email);
            const useDelegation = await MessagingHubFeatures.GetMessagingHubCommandWithDelegation();
            const account = await this.ApplicationService2.getAccount();
            this.botIdentity = account.identity;
            this.featureFlags = FeatureToggleClientService.getInstance().getUserInstance().allFlags();
            this.language = this.TranslateService.getCurrentLanguage();
            this.ownerIdentity = useDelegation ? `${userEmail}/${this.application.shortName}` : this.application.shortName;
            this.token = useDelegation ? userToken : this.application.accessKey;
            this.authEmail = this.AuthenticationService.email;
            this.blipWebsocketHostName = useDelegation ? blipWebsocketHostName : messaginghubWebsocketHostName;
            this.blipWebsocketHostNameTenant = useDelegation ? blipWebsocketHostNameTenant : messaginghubWebsocketHostNameTenant;
            this.notificationEmailLanguage = this.AuthenticationService.getAccount()?.culture;
            this.notificationEmail = this.AuthenticationService.getAccount()?.email;
            this.LoadingService.stopLoading();
            this.readyToRender = true;
        }
        catch (e) {
            console.error('LoadActiveCampaignMfe', e);
        }
    }
    async GetAudiencesSummary(enableLoading) {
        try {
            if (enableLoading) {
                this.LoadingService.startLoading();
            }
            const { items, } = await this.ActiveMessageService.getAudienceSummary(this.skip, this.take, this.search, this.showScheduledOnly).catch(c => console.error(c));
            items.forEach(element => {
                this.convertToActiveCampaign(element);
            });
        }
        catch (e) {
            console.error(e);
        }
        finally {
            if (enableLoading) {
                this.LoadingService.stopLoading();
            }
        }
    }
    async searchDebounce() {
        this.reset();
        await this.GetAudiencesSummary(true);
    }
    async pagination() {
        this.skip += this.take;
        await this.GetAudiencesSummary(true);
    }
    async refreshPage() {
        this.LoadingService.startLoading();
        this.search = '';
        document.getElementById('search-input-field').classList.remove('input-focused');
        this.reset();
        await this.GetAudiencesSummary(true);
        this.LoadingService.stopLoading();
    }
    async openEmbedSignupForLiteApi() {
        clearInterval(this.timerId);
        const extras = "{featureType:'marketing_messages_lite'}";
        const [state, tab] = this.FacebookLoginPopupService.openFacebookLoginPopup(this.nativeAppId, this.graphApiVersion, '', extras, this.MARKETING_MESSAGES_LITE_API_CONFIGID);
        const timeToStopPoolingFacebookCookie = new Date(new Date().getTime() + this.FACEBOOK_POPUP_CONNECTION_TIME);
        const timerId = setInterval(() => {
            if (this.$cookies.getObject(state)) {
                const { code } = this.$cookies.getObject(state);
                clearInterval(timerId);
                if (code) {
                    this.onEmbedSignupFinished(code);
                }
                return;
            }
            if (new Date() > timeToStopPoolingFacebookCookie) {
                clearInterval(this.timerId);
                return;
            }
        }, 2000);
    }
    async onEmbedSignupFinished(code) {
        if (code) {
            this.BlipToastService.show('success', {
                msg: await this.$translate('activeMessages.marketingMessagesLiteApi.successIntegration'),
                duration: BlipToastDuration.NO_TITLE.NO_ACTION,
            });
        }
        else {
            this.BlipToastService.show('danger', {
                msg: await this.$translate('activeMessages.marketingMessagesLiteApi.errorIntegration'),
            });
        }
    }
    async loadApplicationInformation() {
        return await this.ChannelsService.getFacebookAppInformation(ChannelsNames.WhatsApp, this.subsidiary);
    }
    trackSendActiveMessageButton() {
        this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_SENT_ACTIVE_MESSAGE_BUTTON_CLICKED, { applicationOrigin: ActiveMessagesConstants.APPLICATION_ORIGIN });
    }
    isWhatsAppActive() {
        return this.ChannelsService.isChannelActive(ChannelsNames.WhatsApp);
    }
    async sendActiveMessageButtonClicked() {
        this.trackSendActiveMessageButton();
        if (this.phoneNumberDetails?.status == PhoneNumberStatus.Restricted) {
            await this.showRestrictedPhoneNumberAlert();
        }
        else if (this.phoneNumberDetails?.quality_score?.score == PhoneNumberScore.Red) {
            await this.showLowQualityAlert();
        }
        else {
            this.$state.go(ActiveMessagesConstants.SEND_ACTIVE_MESSAGE_STATE);
        }
    }
    downloadReport(activeCampaign) {
        this.isDownloadingReport[activeCampaign.id] = true;
        this.ActiveMessageService.downloadCampaignReport(activeCampaign.id, activeCampaign.name, (err) => {
            this.isDownloadingReport[activeCampaign.id] = false;
            this.disableShowElements(activeCampaign);
            this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_REPORT_BUTTON_CLICKED, { status: err === undefined });
        });
    }
    enableShowElements(activeCampaign) {
        activeCampaign.showElements = true;
    }
    disableShowElements(activeCampaign) {
        const isDownloading = this.isDownloadingReport[activeCampaign.id] || false;
        if (!isDownloading) {
            activeCampaign.showElements = false;
        }
    }
    async showAlertDeleteCampaign(campaignId, campaignName) {
        await this.AlertService.show({
            title: await this.$translate('activeMessages.list.delete.alert.title'),
            body: await this.$translate('activeMessages.list.delete.alert.body', { campaignName }),
            variant: 'delete',
            icon: 'trash',
            buttons: {
                cancel: await this.$translate('activeMessages.list.delete.alert.buttons.cancel'),
                confirm: await this.$translate('activeMessages.list.delete.alert.buttons.confirm'),
            },
            callback: {
                cancelButtonAction: () => { },
                confirmButtonAction: () => { this.deleteCampaign(campaignId); },
            },
        });
    }
    redirectToEditScheduledCampaignState(campaignId) {
        this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_CAMPAIGN_SCHEDULED_EDITED_BUTTON_CLICKED);
        this.$state.go(ActiveMessagesConstants.EDIT_SCHEDULED_CAMPAIGN_STATE, { campaignId });
    }
    async deleteCampaign(campaignId) {
        try {
            const campaign = await this.ActiveMessageService.getCampaign(campaignId);
            const message = await this.ActiveMessageService.getMessage(campaignId);
            await this.ActiveMessageService.deleteCampaign(campaignId);
            this.activeCampaigns = this.activeCampaigns.filter((elmt) => elmt.id != campaignId);
            this.BlipToastService.show('success', {
                msg: await this.$translate('activeMessages.list.delete.tooltip.success.message'),
                duration: BlipToastDuration.NO_TITLE.NO_ACTION,
            });
            const dateTimeTracking = campaign && campaign.scheduled && new Date(campaign.scheduled)
                ? new Date(campaign.scheduled) : undefined;
            const timeTracking = dateTimeTracking !== undefined
                ? dateTimeTracking.getHours() + ':' + dateTimeTracking.getMinutes() : '';
            const dateTracking = dateTimeTracking !== undefined
                ? dateTimeTracking.toLocaleDateString('pt-BR', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                }) : undefined;
            const messageTrack = message !== null && message.items && message.items[0]
                ? message.items[0] : undefined;
            this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_WA_CAMPAIGN_DELETED, {
                activeMessageType: campaign?.campaignType || '',
                applicationOrigin: ActiveMessagesConstants.APPLICATION_ORIGIN,
                content: messageTrack?.messageTemplate || '',
                language: messageTrack?.messageTemplateLanguage || '',
                shippingType: 'Scheduled',
                action: 'delete',
                campaignName: campaign?.name || '',
                scheduleDate: dateTracking,
                scheduleTime: timeTracking,
            });
        }
        catch (e) {
            console.log(e);
            this.BlipToastService.show('danger', {
                title: await this.$translate('activeMessages.list.delete.tooltip.error.title'),
                msg: await this.$translate('activeMessages.list.delete.tooltip.error.message'),
                duration: BlipToastDuration.WITH_TITLE.NO_ACTION,
            });
        }
    }
    convertToActiveCampaign(item) {
        const obj = {
            id: item.id,
            name: item.name,
            channelType: item.channelType,
            isScheduled: item.scheduled != undefined,
            scheduledDate: item.scheduled && this.getDateComponent(item.scheduled),
            scheduledTime: item.scheduled && this.getTimeComponent(item.scheduled),
            total: item.total ?? 0,
            processed: this.changesDisplayActiveCampaignData ? (item.total ?? 0) : (item.processed ?? 0),
            received: item.received ?? 0,
            read: item.read ?? 0,
            failed: item.failed ?? 0,
            sendDate: this.getSendDateComponent(item, this.getDateComponent),
            sendTime: this.getSendDateComponent(item, this.getTimeComponent),
            campaignStatus: item.campaignStatus,
            showElements: false,
            showProcessing: this.isInProcess(item.total, item.failed, item.processed, item.scheduled && new Date(item.scheduled)),
        };
        this.activeCampaigns.push(obj);
    }
    getDateComponent(date) {
        return new Date(date).toLocaleDateString();
    }
    getTimeComponent(date) {
        return new Date(date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
    getSendDateComponent(item, getComponent) {
        if (item.scheduled && new Date(item.scheduled) >= new Date()) {
            return undefined;
        }
        else if (item.scheduled) {
            return getComponent(item.scheduled);
        }
        return getComponent(item.created);
    }
    isInProcess(total, failed, processed, scheduled) {
        return this.showInProcessingActiveCampaignListing && this.verifyScheduledDateReached(scheduled) && processed == 0 && total != failed;
    }
    verifyScheduledDateReached(scheduled) {
        return !scheduled || new Date() >= scheduled;
    }
    clear() {
        this.activeCampaigns = [];
    }
    reset() {
        this.clear();
        this.skip = ActiveMessagesConstants.PAGINATION_DEFAULT_SKIP;
        this.take = ActiveMessagesConstants.PAGINATION_DEFAULT_TAKE;
    }
    async getOrderByOptionsTranslations() {
        this.activeMessageOrderByOptions = [
            {
                value: 'lastUpdate',
                label: await this.$translate('activeMessages.select.lastUpdate'),
            },
            {
                value: 'createdDate',
                label: await this.$translate('activeMessages.select.createdDate'),
            },
        ];
    }
    async GetPhoneNumberQuality() {
        this.phoneNumberQuality = ' ';
        try {
            this.phoneNumberDetails = await this.WhatsAppService.getPhoneNumberDetails();
            switch (this.phoneNumberDetails?.quality_score?.score) {
                case PhoneNumberScore.Yellow:
                    this.phoneNumberQuality = await this.$translate('activeMessages.phoneNumberQuality.average');
                    break;
                case PhoneNumberScore.Red:
                    this.phoneNumberQuality = await this.$translate('activeMessages.phoneNumberQuality.low');
                    break;
                case PhoneNumberScore.Green:
                    this.phoneNumberQuality = await this.$translate('activeMessages.phoneNumberQuality.high');
                    break;
                default:
                    this.phoneNumberQuality = await this.$translate('activeMessages.phoneNumberQuality.unidentified');
                    break;
            }
        }
        catch (error) {
            await this.showErrorToGetPhoneNumberDetailsToast();
        }
    }
    async showErrorToGetPhoneNumberDetailsToast() {
        const toastTitle = await this.$translate('activeMessages.phoneNumberQuality.toasts.errorToGetDetailsTitle');
        const toastBody = await this.$translate('activeMessages.phoneNumberQuality.toasts.errorToGetDetailsBody');
        const toastButtonText = await this.$translate('activeMessages.refresh');
        this.BlipToastService.show('warning', {
            title: toastTitle,
            msg: toastBody,
            buttonText: toastButtonText,
            callback: () => this.$state.reload(),
            duration: 19000,
        });
    }
    async showLowQualityAlert() {
        const alertTitle = await this.$translate('activeMessages.phoneNumberQuality.alerts.lowQualityScore.alertTitle');
        const alertBody = await this.$translate('activeMessages.phoneNumberQuality.alerts.lowQualityScore.alertBody');
        const cancelButton = await this.$translate('activeMessages.phoneNumberQuality.alerts.lowQualityScore.cancelButton');
        const confirmButton = await this.$translate('activeMessages.phoneNumberQuality.alerts.lowQualityScore.confirmButton');
        await this.AlertService.show({
            title: alertTitle,
            body: alertBody,
            variant: 'warning',
            icon: 'info',
            buttons: {
                cancel: cancelButton,
                confirm: confirmButton,
            },
            callback: {
                cancelButtonAction: () => { },
                confirmButtonAction: () => this.$state.go(ActiveMessagesConstants.SEND_ACTIVE_MESSAGE_STATE),
            },
        });
    }
    async showRestrictedPhoneNumberAlert() {
        const alertTitle = await this.$translate('activeMessages.phoneNumberQuality.alerts.restrictedPhoneNumber.alertTitle');
        const alertBody = await this.$translate('activeMessages.phoneNumberQuality.alerts.restrictedPhoneNumber.alertBody');
        const confirmButton = await this.$translate('activeMessages.phoneNumberQuality.alerts.restrictedPhoneNumber.confirmButton');
        await this.AlertService.show({
            title: alertTitle,
            body: alertBody,
            variant: 'error',
            icon: 'error',
            buttons: {
                confirm: confirmButton,
            },
            callback: {
                confirmButtonAction: () => { },
            },
        });
    }
    async showDataLiteApi(campaignId) {
        this.isLoadingLiteApiData[campaignId] = true;
        try {
            const message = await this.ActiveMessageService.getMessage(campaignId);
            const messageInsights = await this.WhatsAppService.getMessageTemplateInsights(message.items[0].messageTemplate);
            const startDate = moment(new Date()).add(-30, 'days').toDate().toLocaleDateString('fr-CA');
            const endDate = moment(new Date()).toDate().toLocaleDateString('fr-CA');
            this.liteApiData = await this.WhatsAppService.getAdsInsights(messageInsights.data[0].ad_id, startDate, endDate);
            this.liteApiData.templateName = message.items[0].messageTemplate;
            this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_VIEW_DATA_LITE_API);
            this.openLiteApiModal();
        }
        catch (e) {
            console.log(e);
            this.GrowthSegmentService.trackEvent(GROWTH_ACTIVE_MESSAGE_ERROR_LITE_API);
            this.BlipToastService.show('danger', {
                msg: await this.$translate('activeMessages.marketingMessagesLiteApi.errorShowData'),
            });
        }
        finally {
            this.isLoadingLiteApiData[campaignId] = false;
        }
    }
    async openLiteApiModal() {
        const modal = await this.ModalService.showModal({
            template: LiteApiModalView,
            controller: LiteApiModalController,
            controllerAs: '$ctrl',
            inputs: {
                data: this.liteApiData,
            },
        });
        await modal.close;
    }
}
ActiveMessagesController.$inject = ['ChannelsService', 'LoadingService', 'ActiveMessageService', 'ModalService', 'application', '$translate', 'GrowthSegmentService', 'WhatsAppService', 'AlertService', '$state', 'BlipToastService', 'AccountService2', 'TranslateService', 'ApplicationService2', 'AuthenticationService', '$cookies', 'FacebookLoginPopupService', 'MARKETING_MESSAGES_LITE_API_CONFIGID', 'FACEBOOK_POPUP_CONNECTION_TIME'];
